import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c823683"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsCarousel: require('/opt/build/repo/components/Elements/Carousel.vue').default,ElementsModal: require('/opt/build/repo/components/Elements/Modal.vue').default})
